import { createFileRoute, Navigate } from '@tanstack/react-router'
import { Loading } from '@/components/ui/loading'
import { useQuickStartProgress } from '@/lib/hooks'
import { AdminOnboardingQuickStart } from '@/components/onboarding/AdminOnboardingQuickStart'
import adminOnboardingBg from '@/assets/admin-onboarding-bg.png'
import pronteerLogoOnboarding from '@/assets/pronteer-logo-onboarding.svg'

export const Route = createFileRoute('/_auth/operations/onboarding')({
  component: AdminOnboardingRoute,
})

function AdminOnboardingRoute() {
  const { data: quickStartProgress, isLoading } = useQuickStartProgress()

  if (isLoading) {
    return (
      <div className="h-full flex items-center justify-center bg-background-brand-bold">
        <Loading size={48} />
      </div>
    )
  }

  if (quickStartProgress?.ownerOnboardingComplete) {
    return <Navigate to="/operations" />
  }

  return (
    <>
      <div
        className="h-full flex items-start justify-center relative overflow-hidden pt-[calc(var(--safe-top)+64px)]"
        style={{
          background: `
            url('${adminOnboardingBg}') center -120px / cover no-repeat
          `,
        }}
      >
        <img
          src={pronteerLogoOnboarding}
          alt="Pronteer"
          className="size-[129px]"
        />
      </div>

      <AdminOnboardingQuickStart steps={quickStartProgress?.steps ?? []} />
    </>
  )
}
